import styled, { keyframes } from 'vue3-styled-components';

export const scanPulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7);
  }
  50% {
    box-shadow: 0 0 15px 5px rgba(76, 175, 80, 0.5);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7);
  }
`;

// 무지개색 애니메이션 정의
export const rainbowBorder = keyframes`
  0% { border-color: #ff0000; box-shadow: 0 0 10px rgba(255, 0, 0, 0.7); }
  14% { border-color: #ff7f00; box-shadow: 0 0 10px rgba(255, 127, 0, 0.7); }
  28% { border-color: #ffff00; box-shadow: 0 0 10px rgba(255, 255, 0, 0.7); }
  42% { border-color: #00ff00; box-shadow: 0 0 10px rgba(0, 255, 0, 0.7); }
  56% { border-color: #0000ff; box-shadow: 0 0 10px rgba(0, 0, 255, 0.7); }
  70% { border-color: #4b0082; box-shadow: 0 0 10px rgba(75, 0, 130, 0.7); }
  84% { border-color: #9400d3; box-shadow: 0 0 10px rgba(148, 0, 211, 0.7); }
  100% { border-color: #ff0000; box-shadow: 0 0 10px rgba(255, 0, 0, 0.7); }
`;

// 배경색 무지개 효과
export const rainbowBackground = keyframes`
  0% { background-color: rgba(255, 0, 0, 0.05); }
  14% { background-color: rgba(255, 127, 0, 0.05); }
  28% { background-color: rgba(255, 255, 0, 0.05); }
  42% { background-color: rgba(0, 255, 0, 0.05); }
  56% { background-color: rgba(0, 0, 255, 0.05); }
  70% { background-color: rgba(75, 0, 130, 0.05); }
  84% { background-color: rgba(148, 0, 211, 0.05); }
  100% { background-color: rgba(255, 0, 0, 0.05); }
`;

// 바코드와 해시태그를 감싸는 컨테이너
export const BarcodeHashtagContainer = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: center;
`;

// 바코드 표시 영역
export const ProdcutlistDetailBarcodeScanArea = styled.div`
    width: 370px;
    padding: 0.75rem;
    background: #f9fafb;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease;

    p {
        font-size: 16px;
        font-weight: 600;
        color: #1f2937;
        margin-bottom: 0.5rem;
    }

    &:hover {
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
        transform: translateY(-2px);
    }
`;

// 해시태그 영역
export const HashtagArea = styled.div`
    width: 350px;
    padding: 10px;
    background: #f9fafb;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease;

    p {
        font-size: 16px;
        font-weight: 600;
        color: #1f2937;
        margin-bottom: 0.5rem;
    }

    &:hover {
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
        transform: translateY(-2px);
    }
`;

export const HashtagContent = styled.div`
    background: white;
    padding: 0.75rem;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    min-height: 50px;
    transition: border-color 0.2s ease;

    .hashtag-list {
        display: flex;
        flex-wrap: wrap;
        gap: 0.35rem;
        margin-bottom: ${props => props.isEditMode ? '0.5rem' : '0'};
    }

    .hashtag-item {
        display: inline-flex;
        align-items: center;
        background: #ecf4ff;
        padding: 0.25rem 0.5rem;
        border-radius: 15px;
        font-size: 0.75rem;
        color: #2563eb;
        font-weight: 500;
        
        &:hover {
            background: #dbeafe;
            transform: translateY(-1px);
        }
    }

    .hashtag-delete {
        background: none;
        border: none;
        color: #6b7280;
        cursor: pointer;
        padding: 0 0 0 0.25rem;
        font-size: 0.875rem;
        line-height: 1;
        
        &:hover {
            color: #ef4444;
        }
    }

    .no-tags {
        color: #9ca3af;
        font-size: 14px;
    }
`;

export const BarcodeDisplayArea = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.75rem;
    height: 55px;
    background: white;
    border-radius: 8px;
    border: 2px solid #e5e7eb;
    transition: all 0.2s ease;

    .barcode-status-container {
        flex: 1;
        margin-right: 0.5rem;
        display: flex;
        align-items: center;
        min-width: 0;
        max-width: 100%;
    }
    
    .barcode-empty {
        display: flex;
        align-items: center;
        color: #9ca3af;
        font-size: 15px;
        width: 100%;
        
        .material-design-icon {
            flex-shrink: 0;
            color: #ef4444;
            margin-top: 3px;
            margin-right: 8px;
        }
        
        .material-design-icon__svg {
            fill: #ef4444;
        }
    }
    
    .barcode-value {
        display: flex;
        align-items: center;
        width: 100%;
        min-width: 0;
        
        .material-design-icon {
            flex-shrink: 0;
            color: #3b82f6;
            margin-top: 2px;
            margin-right: 8px;
        }
        
        .material-design-icon__svg {
            fill: #3b82f6;
        }
        
        .barcode-number {
            font-family: 'Roboto Mono', monospace;
            font-size: 25px;
            font-weight: 600;
            color: #111827;
            letter-spacing: 0.5px;
            background: linear-gradient(to right, #4f46e5, #3b82f6);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
        }
    }

    &:hover {
        border-color: #d1d5db;
    }

    &.scanning {
        border-width: 2px;
        animation: ${rainbowBorder} 4s linear infinite;
        background-color: white;
        position: relative;
        overflow: hidden;
        
        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(255, 255, 255, 0.85);
            z-index: -1;
            animation: ${rainbowBackground} 4s linear infinite;
        }
    }

    .ScanButton, .DeleteBarcodeBtn {
        flex-shrink: 0;
    }
`;

export const ScanButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  background-color: #0f4c5c;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  gap: 6px;

  .material-design-icon {
    color: white !important;
    margin-top: 3px;
    vertical-align: middle;
  }
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }
  
  &.active {
    background-color: #F44336;
    
    &:hover {
      background-color: #D32F2F;
    }
  }
`;

export const DeleteBarcodeBtn = styled.button`
    padding: 0.35rem 0.75rem;
    background-color: #ef4444;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 0.75rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background-color: #dc2626;
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(1px);
    }
`;

export const ProductListDetailArea = styled.div`
    width: 100%;
    margin: 0 auto;
    background: #fff;
    border-radius: 16px;
    box-sizing: border-box;
    max-width: 100%;
    overflow-x: hidden;
    position: relative;
    padding-bottom: 130px;
`;

export const ProductlistDetailModalArea = styled.div`
    width: 100%;
    height: 100%;
    max-width: 1400px;
    margin: 0 auto;
`;

// 버튼 하단 컨테이너
export const ProductListDetailBtnContainerEnd = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    gap: 1rem;
    padding-top: 1rem;
    background: white;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 10;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
`;

// 공통 액션 버튼 스타일
export const ActionButton = styled.button`
    padding: 0.85rem 1.75rem;
    border-radius: 10px;
    font-weight: 600;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    transition: all 0.25s ease;
    border: none;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 6px 12px rgba(0,0,0,0.15);
    }

    &:active {
        transform: translateY(1px);
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    }
`;

export const ProdcutDetailModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 15px;
    border-bottom: 1px solid #f3f4f6;
    margin-bottom: 20px;
    gap: 2rem;
`;

// 왼쪽 섹션 (품목명)
export const HeaderTopSection = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    gap: 0;
    min-width: 0;
    overflow: hidden;

    .qr-code-section {
        display: flex;
        align-items: center;
        gap: 15px;
        margin-left: 0;
        flex-shrink: 0;

        img {
            width: 60px;
            height: 60px;
            object-fit: cover;
            border-radius: 8px;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
            transition: transform 0.2s ease;
            
            &:hover {
                transform: scale(1.05);
            }
        }
    }
`;

export const ProductListDetailModalHeaderTitle = styled.div`
    display: flex;
    align-items: center;
    font-size: 28px;
    font-weight: 700;
    color: #111827;
    letter-spacing: -0.02em;
    flex: 1;
    min-width: 0;
    overflow: hidden;

    // 텍스트 말줄임표 처리
    &.text-truncate {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        max-width: 100%;
        display: block;
    }
    
    .qr-code-section{
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

// 이미지 스타일
export const ProductlistDetailImg = styled.img`
    width: 100%;
    height: 420px;
    object-fit: contain;
    border-radius: 12px;
    background: #f9fafb;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

    &:hover {
        transform: scale(1.03);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
    }
`;

// 모달 콘텐츠 영역
export const ProdcutDetailModalContent = styled.div`
    display: flex;
    justify-content: flex-start;
    gap: 2.5rem;
    flex-wrap: wrap;
`;

// 이미지 섹션
export const ProductImageSection = styled.div`
    flex: 0 0 420px; // 너비를 320px로 줄임
    position: relative;
    background: #fff;
    margin-bottom: 2rem;
    aspect-ratio: 1 / 1; // 정사각형 비율 설정
`;

// 이미지 입력 컨테이너
export const ImageInputContainer = styled.div`
    width: 95%;
    text-align: center;
    margin-top: 1rem;

    input[type="file"] {
        width: 100%;
        padding: 0.75rem;
        background: rgba(255, 255, 255, 0.95);
        border-radius: 8px;
        border: 1px solid #e5e7eb;
        font-size: 0.95rem;
        transition: border-color 0.2s ease;
        
        &:hover {
            border-color: #d1d5db;
        }
        
        &:focus {
            outline: none;
            border-color: #3b82f6;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
        }
    }
`;

// 정보 섹션
export const ProductInfoSection = styled.div`
    flex: 1;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1.25rem;
    margin-bottom: 10px;
`;

// 정보 카드
export const InfoCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #f1f5f9;
    padding: 10px;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    width: 90%;
    transition: all 0.2s ease;
    overflow: hidden;
    max-width: 100%;

    &:hover {
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
        transform: translateY(-2px);
    }

    &.full-width {
        grid-column: span 1; // 1칸을 차지하도록 설정
        width: 90%; // 너비를 약간 더 넓게 설정
    }
`;

export const InfoCardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

// 정보 레이블
export const InfoLabel = styled.div`
    font-size: 16px;
    font-weight: 600;
    color: #4b5563;
`;

// 정보 값
export const InfoValue = styled.div`
    flex: 1;
    font-size: 14px;
    color: #111827;
    min-height: 25px;
    display: flex;
    align-items: center;
    padding-top: 5px;

    input {
        height: 32px;
        padding: 0 8px;
        margin: 0;
        line-height: 32px;
        vertical-align: middle;
    }

    &.price_area {
        .price-display {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            gap: 1rem;

            .price-text {
                font-weight: 600;
                font-size: 1rem;
                color: #111827;
                padding-left: 20px;
                line-height: 32px;
            }

            .quantity-text {
                font-weight: 600;
                font-size: 1rem;
                color: #111827;
                line-height: 32px;
            }
        }

        .price-edit-container {
            display: flex;
            align-items: center;
            gap: 5px;
            width: 100%;
            padding-left: 20px;

            .price-input {
                width: 60px;
                height: 32px;
                text-align: center;
                font-size: 0.95rem;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                transition: all 0.2s ease;
                line-height: 32px;
                
                &:focus {
                    outline: none;
                    border-color: #3b82f6;
                    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
                }
            }
        }
    }
`;

// 제조사 발주 버튼
export const ManufacturerOrderBtn = styled.div`
    display: flex;
    align-items: center;
    padding: 6px 10px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    border-radius: 5px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.25);
    white-space: nowrap;
    min-width: 50px;
    justify-content: center;
    margin-left: 10px;

    &:hover {
        background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.35);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 2px 6px rgba(102, 126, 234, 0.25);
    }
`;

export const QuantityBtn = styled.button`
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 8px;
    background-color: #4b5563;
    color: white;
    font-size: 1.25rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);

    &:hover {
        background-color: #374151;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    }

    &:active {
        transform: translateY(1px);
        box-shadow: none;
    }
`;

// 수량 조절 관련 스타일
export const QuantityContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
`;

export const QuantityBtnArea = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: 5px;
`;

export const QuantityBtnArea2 = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
`;

export const QuantityInput = styled.input`
    width: 40px;
    height: 25px;
    text-align: center;
    border-radius: 6px;
    font-weight: 600;
    border: 1px solid #e5e7eb;
    font-size: 1rem;
    transition: all 0.2s ease;
    
    &:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`;

export const ProductListDetailInput = styled.input`
    width: 90%;
    height: 35px;
    text-align: center;
    font-size: 13px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 0 10px;
    margin-bottom: 10px;
    transition: all 0.2s ease;
    
    &:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
    }
`;

export const ProductListDetailSelect = styled.select`
    width: 100%;
    height: 35px;
    text-align: center;
    font-size: 13px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 0 10px;
    background-color: white;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
    }
`;

// * 버튼 스타일
export const ProductListDetailBtn = styled.div`
    min-width: 60px;
    padding: 6px;
    text-align: center;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    font-size: 0.9rem;
    background-color: #f3f4f6;
    color: #1f2937;

    &.save-btn, &.edit-btn {
        min-width: 40px;
    }

    &:hover {
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        background-color: #0f4c5c;
        color: white;
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 1px 2px rgba(0,0,0,0.1);
    }
`;

// 정보 수정 버튼
export const ProductListDetailEditBtn = styled(ActionButton)`
    background: #3b82f6;
    color: white;

    &:hover {
        background: #2563eb;
    }

    &:active {
        background: #1d4ed8;
    }
`;

// 품목 삭제 버튼
export const ProductListDetailDeleteBtn = styled(ActionButton)`
    background: #ef4444;
    color: white;

    &:hover {
        background: #dc2626;
    }

    &:active {
        background: #b91c1c;
    }
`;

// 저장 버튼
export const ProductListDetailSaveBtn = styled(ActionButton)`
    background: #10b981;
    color: white;

    &:hover {
        background: #059669;
    }

    &:active {
        background: #047857;
    }
`;

// 취소 버튼
export const ProductListDetailCancelBtn = styled(ActionButton)`
    background: #6b7280;
    color: white;

    &:hover {
        background: #4b5563;
    }

    &:active {
        background: #374151;
    }
`;

// 이미지 삭제 버튼
export const ProductListDetailImageDeleteBtn = styled.button`
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(239, 68, 68, 0.9);
    color: white;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    transition: all 0.2s ease;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);

    &:hover {
        background: #dc2626;
        transform: scale(1.1);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
    }

    &:active {
        transform: scale(0.95);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
    }
`;

// 옵션 추가 버튼
export const ProductListDetailPlusBtn = styled(ActionButton)`
    background: #10b981;
    color: white;

    &:hover {
        background: #059669;
    }

    &:active {
        background: #047857;
    }
`;

export const InfoLabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const IconTooltip = styled.span`
  position: absolute;
  bottom: -35px;  // top 대신 bottom으로 변경
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s, visibility 0.2s;
  z-index: 1000;  // z-index 값을 높여서 항상 위에 표시되도록
  pointer-events: none;
  
  &:after {
    content: '';
    position: absolute;
    top: -5px;  // bottom 대신 top으로 변경
    left: 50%;
    transform: translateX(-50%);
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #333;  // border-top 대신 border-bottom으로 변경
    border-top: none;  // 기존 border-top 제거
  }
`;

export const SearchIconButton = styled.button`
  cursor: pointer;
  color: #0f4c5c;
  border: none;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  padding: 0;
  position: relative;
  
  &:hover {
    background-color: rgba(15, 76, 92, 0.1);
    
    span {
      opacity: 1;
      visibility: visible;
    }
  }
  
  &:disabled {
    color: #ccc;
    cursor: not-allowed;
    
    &:hover {
      background-color: transparent;
      
      span {
        opacity: 1;
        visibility: visible;
      }
    }
  }
`;